export default class PageTitleComponent {

    constructor() {
        this.template = require('./page.title.view.html');
        this.controller = PageTitleController;

        this.bindings = {
            title: '@',
            pageEntity:'@',
	        onDistribute: '&?',
            enableDistribute: '<',
	        onCloneBundleVersion: '&?',
	        enableCloneBundleVersion: '<',
	        onToggleArchive: '&?',
	        enableArchive: '<',
	        isArchivedBundle: '<',
	        onDelete: '&?',
	        enableDelete: '<',
	        onStopDistribution: '&?',
	        hasActiveDistribution: '<',
	        onEdit: '&?',
	        enableEdit: '<?',
	        isEditable:'<?',
	        onSign:'&?',
        };

    }
};
PageTitleComponent.META = {
    name: 'pageTitle'
};

class PageTitleController {
    constructor($scope, JFrogEventBus) {
        this.$scope = $scope;
        this.jFrogEventBus = JFrogEventBus;
    }

    $onInit() {

    }

    setQuickActions() {
        if (!this.quickActions) {
            return;
        }
        this.quickActions.setActionsDictionary(this.getActionsDictionary());
        this.quickActions.setActions(this.getActions());
    }

    initQuickActions(actionsController) {
        this.quickActions = actionsController;
        this.setQuickActions();
    }

    getActionsDictionary() {
        let dictionary = {};
        dictionary.edit = {title: 'Edit Version'};
        dictionary.sign = {title: 'Sign Version'};
        dictionary.distribute = {title: 'Distribute Version'};
	    dictionary.cloneBundleVersion = {title: 'Clone Version'};
	    dictionary.archive = {title: 'Archive Version'};
	    dictionary.unArchive = {title: 'Un-Archive Version'};
	    dictionary.delete = {title: 'Delete Version'};
	    dictionary.stop = {title: 'Stop Distribution'};
        return dictionary;
    }

    getActions() {
        let actions = [{
	        name: 'edit',
	        icon: 'icon-edit-pen bordered',
	        action: () => {
		        this.onEdit();
	        },
	        disabledWhen: () => !this.isEditable,
	        visibleWhen: () => this.onEdit && this.enableEdit
        },{
	        name: 'sign',
	        icon: 'icon-private-repository bordered',
	        action: () => {
		        this.onSign();
	        },
	        disabledWhen: () => !this.isEditable,
	        visibleWhen: () => this.onSign && this.enableEdit
        },{
	        name: 'cloneBundleVersion',
	        icon: 'icon-copy bordered',
	        action: () => {
		        this.onCloneBundleVersion();
	        },
	        visibleWhen: () => this.onCloneBundleVersion && this.enableCloneBundleVersion
        },{
	        name: 'archive',
	        icon: 'icon-archive bordered',
	        action: () => {
		        this.onToggleArchive();
	        },
	        visibleWhen: () => this.onToggleArchive && this.enableArchive && !this.isArchivedBundle
        },{
	        name: 'unArchive',
	        icon: 'icon-archive bordered',
	        action: () => {
		        this.onToggleArchive();
	        },
	        visibleWhen: () => this.onToggleArchive && this.enableArchive && this.isArchivedBundle
        },{
	        name: 'distribute',
	        icon: 'icon-distribution-repo bordered',
	        action: () => {
		        this.onDistribute();
	        },
	        disabledWhen: () => this.isEditable,
	        visibleWhen: () => this.onDistribute && this.enableDistribute
        },{
	        name: 'stop',
	        icon: 'icon-stop bordered',
	        action: () => {
		        this.onStopDistribution();
	        },
	        disabledWhen: () => !this.hasActiveDistribution,
	        visibleWhen: () => this.onStopDistribution && this.enableDistribute
        },{
	        name: 'delete',
	        icon: 'icon-clear bordered',
	        action: () => {
		        this.onDelete();
	        },
	        visibleWhen: () => this.onDelete && this.enableDelete
        }];
        return actions;
    }
}

PageTitleController.$inject = ['$scope', 'JFrogEventBus'];



// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-page-title/page.title.component.js